<template>
  <!--form表单-->
  <div class="form-plus">
    <el-form :inline="true" class="demo-form-inline" :model="formData">
      <el-form-item
        :label="item.label"
        v-for="(item, index) in formList"
        :key="index"
      >
        <el-input
          v-if="item.type == 'input'"
          v-model="formData[item.vModel]"
          :placeholder="item.placeholder"
          clearable
          @keyup.enter.native="enter(item)"
          @clear="clear(item)"
        ></el-input>

        <el-autocomplete
          v-else-if="item.type == 'autocomplete'"
          v-model="formData[item.vModel]"
          :fetch-suggestions="item.fetchSuggestions"
          :placeholder="item.placeholder"
          clearable
          @keyup.enter.native="enter(item)"
          @clear="clear(item)"
        ></el-autocomplete>

        <el-cascader
          v-else-if="item.type == 'cascader'"
          filterable
          :props="item.props"
          v-model="formData[item.vModel]"
          @change="item.changeFn"
          clearable
        ></el-cascader>

        <el-select 
          v-else-if="item.type == 'select'" 
          v-model="formData[item.vModel]" 
          :placeholder="item.placeholder"
          >
          <el-option label="全部" value=""></el-option>
          <el-option 
            :label="option[item.optionLabel] || option.label" 
            :value="option[item.optionValue] || option.value" 
            v-for="option in item.optionData" 
            :key="option[item.optionValue] || option.value"
          ></el-option>
        </el-select>

        <el-date-picker
          v-else-if="item.type == 'date-picker'" 
          class="filter-timer"
          v-model="formData[item.vModel]" 
          :type="item.dataMode || 'date'"
          :placeholder="item.placeholder"
          range-separator="至"
          :start-placeholder="item.startPlaceholder || '开始日期'"
          :end-placeholder="item.endPlaceholder || '结束日期'"
          @change="item.changeFn"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          :picker-options="pickerOptions"
          unlink-panels>
        </el-date-picker>
        
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  name: "FormPlus", 
  props: {
    formList: {
      type: Array,
      default: () => [],
    },
    formData: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '最近一天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 );
            picker.$emit('pick', [start, end]);
          }
        },{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近二年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * (365 * 2));
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * (365 * 3));
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    };
  },
  created(){
  },
  methods: {
    clear(item){
      this.$emit('clear',item)
    },
    enter(item){
      this.$emit('enter',item)
    }
  },
  watch: {},
};
</script>
<style scoped lang="less">
.form-plus {
}
</style>